import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface Shortcut {
    id: number
    userId: number
    title: string
    path: string
    createdAt: string
    updatedAt: string
}

interface ShortcutsState {
    shortcuts: Shortcut[]
    loading: boolean
    error: string | null
}

const initialState: ShortcutsState = {
    shortcuts: [],
    loading: false,
    error: null,
}

const shortcutsSlice = createSlice({
    name: 'shortcuts',
    initialState,
    reducers: {
        setShortcuts: (state, action: PayloadAction<Shortcut[]>) => {
            state.shortcuts = action.payload
            state.loading = false
            state.error = null
        },
        addShortcut: (state, action: PayloadAction<Shortcut>) => {
            state.shortcuts.unshift(action.payload)
        },
        removeShortcut: (state, action: PayloadAction<number>) => {
            state.shortcuts = state.shortcuts.filter(
                s => s.id !== action.payload
            )
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
            state.loading = false
        },
    },
})

export const {
    setShortcuts,
    addShortcut,
    removeShortcut,
    setLoading,
    setError,
} = shortcutsSlice.actions
export default shortcutsSlice.reducer
